<template>
  <div id="main-content" class="edit-sub-driver">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8"><span class="required-star">* </span><span class="form-lable">{{ $t('common.title') }}</span></el-col>
            <input class="input" v-model="busNotificationTemplateInfo.title" type=""/>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span>
              <span class="form-lable">{{ $t('common.category') }}</span>
            </el-col>
            <select style="" class="input" v-model="busNotificationTemplateInfo.category_info.id">
              <option value="">{{ $t('common.please_select') }}</option>
              <option v-for="category in categoriesList" v-bind:key="category.id" :value="category.id">{{ category.name }}</option>
            </select>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8"><span class="required-star">* </span><span class="form-lable">{{ $t('common.content') }}</span></el-col>
            <b-form-textarea
              style="float: left !important;"
              id="textarea"
              v-model="busNotificationTemplateInfo.content"
              placeholder=""
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </el-col>
        </el-row>
        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '../../components/PageTitle.vue'
  import {mapState} from 'vuex'

  export default {
    name: "EditBusNotificationTemplate",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/bus-notification-template/detail?tid=${this.$route.query.tid}`,
        title: this.$t('notification.edit_bus_notification_template'),
      }
    },
    mounted: function () {
      let successCallback = () => {
      };
      let payload = {
        successCallback,
        bus_notification_template_id: this.$route.query.tid
      }
      this.$store.dispatch('busnotificationtemplate/getBusNotificationTemplateInfo', payload)
      this.$store.dispatch('busnotificationtemplate/retrieveBusNotificationCategoryList', {})
    },
    computed: {
      ...mapState('busnotificationtemplate', ['busNotificationTemplateInfo']),
      ...mapState('busnotificationtemplate', ['categoriesList']),
    },
    methods: {
      submitAction: function () {
        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push({path: '/bus-notification-template/detail', query: {tid: this.$route.query.tid}});
          }
          this.busNotificationTemplateInfo.category_id = this.busNotificationTemplateInfo.category_info.id
          let payload = {
            successCallback,
            data: this.busNotificationTemplateInfo,
            bus_notification_template_id: this.$route.query.tid
          }
          this.$store.dispatch('busnotificationtemplate/editBusNotificationTemplate', payload);
        }
      },
      validate: function () {
        return true
      },
    }
  }
</script>

<style scoped>

</style>